/* eslint-disable max-classes-per-file */
import { createAction, props } from '@ngrx/store';
import { RequestPasswordReset } from './forgot.model';

export const ActionTypes = {
  REQUEST_RESET: '[Auth] Request Reset',
  REQUEST_RESET_SUCCESS: '[Auth] Request Reset Success',
  REQUEST_RESET_FAILURE: '[Auth] Request Reset Failure',
};

export const requestReset = createAction(
  ActionTypes.REQUEST_RESET,
  props<{ payload: RequestPasswordReset }>()
);

export const requestResetSuccess = createAction(
  ActionTypes.REQUEST_RESET_SUCCESS
);

export const requestResetFailure = createAction(
  ActionTypes.REQUEST_RESET_FAILURE,
  props<{ payload: string }>()
);
